import axios from "axios"
import { IURI } from "./types"
import logger from "./logger"
import program from "./commander"

const { Id, currency, assets, verbose } = program

const { root, version, path }: IURI = {
  root: "https://api.coingecko.com/api/",
  version: "v3",
  path: "/simple/price",
}
const URI: string = `${root}${version}${path}?ids=${Id}&vs_currencies=${currency}`

const getSimplePrice = async () => {
  try {
    const { data } = await axios.get(URI)

    const token = data[Id.toLowerCase()]

    let price: number = token?.[currency.toLowerCase()]
    return logger.log(Id, price, currency, assets, verbose)
  } catch (e) {
    if (!e.isAxiosError) console.log(e)

    !e.response
      ? console.error("Can't connect to the API. Check your connection.")
      : console.log(e.response.data)

    process.exit(1)
  }
}

export { getSimplePrice }
